module.exports = __webpack_public_path__ + "static/media/key-skeleton.56c514f1.svg";